import React, { useState } from "react";
import "./Header.css";
import { Link, useLocation } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import BurgerMenu from "./burgerMenu/BurgerMenu";

const Header = () => {
  // when scroll header at top
  window.addEventListener("scroll", function () {
    const header = document.querySelector(".header");
    header?.classList.toggle("active", window.scrollY > 80);
  });

  const [showBurger, setShowBurger] = useState(false);

  return (
    <header className="header d-flex">
      <div className=" d-flex content">
        <div className="left-header">
          <img src="/pic/logo.png" alt="logo" />
          <p
            style={{
              color:
              window.location.pathname !=="/" || window.location.pathname === "/certificates"
                  ? "var(--darkBrown)"
                  : "var(--white)",
            }}
          >
            آرد زر
          </p>
        </div>
        <ul className="right-header">
          {/* <li> */}
          <Dropdown>
            <Dropdown.Toggle
              style={{
                color:
                window.location.pathname !=="/" && window.location.pathname !== "/certificates"
                    ? "var(--darkBrown)"
                    : "var(--white)",
              }}
            >
              امور سهام 
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item>بورس</Dropdown.Item>
              <Dropdown.Item>کدال</Dropdown.Item>
              <Dropdown.Item>مدیریت سهامداران</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          {/* </li> */}
          <li>
            <Link
              to="/contactUs"
              style={{
                color:
                window.location.pathname !=="/" && window.location.pathname !== "/certificates"
                    ? "var(--darkBrown)"
                    : "var(--white)",
              }}
            >
              ارتباط با ما
            </Link>
          </li>
          <li>
            <Link
              style={{
                color:
                window.location.pathname !=="/" && window.location.pathname !== "/certificates"
                    ? "var(--darkBrown)"
                    : "var(--white)",
              }}
              to="/certificates"
            >
              گواهینامه ها
            </Link>
          </li>
          <li>
          <Link
              style={{
                color:
                window.location.pathname !=="/" && window.location.pathname !== "/certificates"
                    ? "var(--darkBrown)"
                    : "var(--white)",
              }}
              to="/news"
            >
              اخبار و مقالات
            </Link>
          </li>
          <li>
            <Link
              style={{
                color:
                window.location.pathname !=="/" && window.location.pathname !== "/certificates"
                    ? "var(--darkBrown)"
                    : "var(--white)",
              }}
              to="/products"
            >
              محصولات
            </Link>
          </li>
          <li>
            <Link
              style={{
                color:
                window.location.pathname !=="/" && window.location.pathname !== "/certificates"
                    ? "var(--darkBrown)"
                    : "var(--white)",
              }}
              to="/aboutUs"
            >
              درباره ما
            </Link>
          </li>
          <li>
            <Link
              style={{
                color:
                window.location.pathname !=="/" && window.location.pathname !== "/certificates"
                    ? "var(--darkBrown)"
                    : "var(--white)",
              }}
              to="/"
            >
              صفحه اصلی
            </Link>
          </li>
        </ul>
      </div>
      <div className="show-burger">
        <img src="/pic/logo.png" alt="logo-semolina" />
        <i
          role="button"
          className="fa fa-bars"
          onClick={() => setShowBurger(true)}
          style={{
            color:
              useLocation().pathname !== "/"
                ? "var(--darkBrown)"
                : "var(--white)",
          }}
        ></i>
      </div>
      {showBurger && (
        <BurgerMenu showBurger={showBurger} setShowBurger={setShowBurger} />
      )}
    </header>
  );
};

export default Header;
